<template>
    <div id="institution_c">
        <div style="height: 120px;border-bottom: 2px dashed #eee">
            <el-row>
                <el-col>
                    <span class="demonstration" style="border-radius: 5px;margin-right: 15px">年月</span>
                    <el-date-picker
                            @click.native="typeChange"
                            style="width: 160px;margin-right: 50px"
                            v-model="dateValue"
                            type="month"
                            placeholder="选择年月">
                    </el-date-picker>
                    <el-checkbox label="只显示目标客户" name="type"></el-checkbox>

                    <div style="float: right">
                        <span style="margin-right: 15px">人员</span>
                        <inputSelect :handleSelectInput="handleSelectInputClick"></inputSelect>
                    </div>
                </el-col>
                <el-col span="24" style="margin-top: 24px">
                    <el-button type="primary" size="small" @click="searchWeekList"
                               style="background: #4EC880;border: none">
                        查询
                    </el-button>
                    <el-button type="danger" size="small" @click="ResetClick"
                               style="background: #D0021B;border: none">
                        重置
                    </el-button>
                </el-col>
            </el-row>
        </div>
        <el-row  style="margin-top: 20px">
            <el-col span="24">
                 <span style="vertical-align:middle;font-size: 17px">
                    2019年9月
                </span>
                <span style="font-size: 12px;margin-left: 10px;color:#FF9901;vertical-align:middle">
                    目标客户 128人
                </span>
                <span style="font-size: 12px;margin-left: 10px;color: #4A90E2;vertical-align:middle">
                    辖区内共有328名HCP
                </span>
            </el-col>
            <el-col span="7">
                <div id="institution_c_room_one" style="width:100%;height: 230px;"></div>
            </el-col>
            <el-col span="1" style="border: 1px transparent solid;">
                <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">

                </div>
            </el-col>
            <el-col :span="7" style="">
                <div id="institution_c_room_two" style="width:100%;height:230px;"></div>
            </el-col>
            <el-col span="1" style="border: 1px transparent solid;">
                <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">

                </div>
            </el-col>
            <el-col :span="7" style="">
                <div id="institution_c_room_three" style="width:100%;height: 230px;"></div>
            </el-col>
            <el-col span="24">
                <el-row >
                    <el-col span="7" style="text-align: center;color: #3998f7">科室分布</el-col>
                    <el-col span="1" style="border: 1px transparent solid;"></el-col>
                    <el-col span="7" style="text-align: center;color: #3998f7">级别分布</el-col>
                    <el-col span="1" style="border: 1px transparent solid;"></el-col>
                    <el-col span="7" style="text-align: center;color: #3998f7">接受度分布</el-col>
                </el-row>
            </el-col>

        </el-row>

        <el-row style="margin-top: 20px">
            <el-table
                      :data="tableData"
                      style="width: 100%">
                <el-table-column
                        prop="date"
                        label="医生姓名"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="所在机构"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="所在科室"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="职务">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="职称">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="客户等级">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="是否目标客户">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import inputSelect from '../../../../calendar/components/components/inputSelect'
    export default {
        name: "institution",
        data(){
            return {
                form:{},
                tableData: [{
                    date: '王晓云',
                    name: '4',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '3',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }],
                onoff:false,
                roomChart:'',
                gradeChart:'',
                threeChart:'',
                max:10,
                // value:6.7,
                // iconClasses: [divGreen, divGreen, divGreen],
                value1: 10,
                value2: 8.3,
                value3: 10,
                value4: 5.2,
                iconClasses: ['iconfont icon-shixinzhengfangxing', 'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing', 'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing', 'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing'],
                colors:['#ED3B3F','#FF9901','#7ED321'],
                dateValue2:'',
                dateValue:'',
            }
        },
        components:{
            inputSelect
        },
       mounted(){
           this.init()

           window.onresize = () => {
               this.roomChart.resize()
               this.gradeChart.resize()
           }
       },
        methods:{
            init(){

                this.roomChart=this.$echarts.init(document.getElementById('institution_c_room_one'));
                this.gradeChart=this.$echarts.init(document.getElementById('institution_c_room_two'));
                this.threeChart=this.$echarts.init(document.getElementById('institution_c_room_three'));
                let optins ={
                    title : {
                        text: '',
                        x:'center',
                        y: 'bottom',
                        textStyle:{
                            color:"#6fa7e8"
                        }
                    },
                    series : [
                        {
                            name: '访问来源',
                            type: 'pie',    // 设置图表类型为饼图
                            radius: '50%',
                            label : {
                                normal : {
                                    formatter: '{w|{b} {d}%}\n{n|({c}人)}',
                                    rich: {
                                        w:{
                                            fontSize : 15,
                                            color:'#ff9901'
                                        },
                                        n:{
                                            color: '#fff',
                                            align: 'center',
                                            fontSize: 15,
                                        }

                                    }
                                }
                            },
                            data:[
                                {value:31, name:'D类'},
                                {value:29, name:'C类'},
                                {value:13, name:'B类'},
                                {value:14, name:'A类'},
                            ],
                            center:["50%","40%"]
                        }
                    ],
                    color:["#50e3c2","#63a9fa","#d16366","#fecfa3"]
                }
                this.roomChart.setOption(optins)
                this.gradeChart.setOption(optins)
                this.threeChart.setOption(optins)

            },
            handleSelectInputClick(){

            },
            typeChange(){
               if (this.onoff){
                   this.onoff = false
                   this.$nextTick( ()=>{
                       // this.init()
                       //
                       // window.onresize = () => {
                       //     this.roomChart.resize()
                       //     this.gradeChart.resize()
                       // }
                   })
               } else {
                   // this.roomChart.clear()
                   // this.gradeChart.clear()
                   this.onoff = true
               }


            }

        }
    }
</script>

<style scoped>
   #institution_c .custDiv_border:before{
        content:" ";
        height: 100px;
        border: 1px solid #9FA5AC;
        float: right;
        margin-top: 40px;
    }
   #institution_c >>> .el-progress-bar{
       padding-right: 60px;
   }
   #institution_c >>> .el-progress-bar__outer{
      border-radius: 2px;
  }
   #institution_c >>> .el-progress-bar__inner{
        border-radius: 2px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/summarize/components/institution.vue